<script>
import Dropdown from '../../../components/Dropdown.vue';
import AddStepDropdown from './AddStepDropdown.vue';

import ButtonNext from 'next/button/Button.vue';

export default {
  components: {
    Dropdown,
    AddStepDropdown,
    ButtonNext,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['addStep', 'deleteStep'],
  data() {
    return {
      showDropdown: false,
      event: {},
    };
  },
  methods: {
    openDropdown(event) {
      this.showDropdown = true;
      this.event = event;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
  },
};
</script>

<template>
  <div>
    <div class="add-step-button">
      <ButtonNext
        size="xs"
        icon="i-lucide-circle-plus"
        color="teal"
        class="!rounded-full z-10 p-0 pointer-events-auto [&>span]:size-[18px]"
        :disabled="disabled"
        @click="openDropdown"
      />
    </div>

    <Dropdown
      class="pointer-events-auto"
      :show-dropdown="showDropdown"
      :event="event"
      @close="closeDropdown"
    >
      <AddStepDropdown
        v-if="showDropdown"
        @close="closeDropdown"
        @add="e => $emit('addStep', e)"
        @delete="e => $emit('deleteStep', e)"
      />
    </Dropdown>
  </div>
</template>

<style lang="scss" scoped>
.add-step-button {
  @apply bg-white dark:bg-slate-900 rounded-full;
  transform: var(--transform);
  ::v-deep .icon {
    @apply w-full h-full;
  }
}
</style>
